import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import BlogAbout from '../../components/blog-about'
import BlogComments from '../../components/blog-comments'
import BlogSidebar from '../../components/blog-sidebar'
import Footer from '../../components/footer'

import bg from '../../assets/images/bg.jpg'

export default function BlogLinkPost() {
  return (
    <>
    <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg})`, backgroundPosition:'center'}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">Link Post</h4>
                          <p className="text-muted mb-0">We present and write attractive blog posts with Sidebar</p>
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Blog</Link></li>
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Link Post</span>
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>

    <ShapeTwo/>
    <section className="section">
        <div className="container">
            <div className="row">
                <div className="col-lg-8 col-md-6">
                    <div className="card blog blog-primary text-center border-0 rounded-0">
                        <div className="bg-soft-primary rounded-3 p-4">
                            <Link to="#!" className="tag h6 text-decoration-underline">XYZ Tag</Link>
                            <div className="position-relative">
                                <span className="blog-icon mx-auto my-3 rounded-circle bg-white"><i
                                        className="mdi mdi-24px mdi-link-variant"></i></span>
                            </div>


                            <Link to="#!" className="title h4 text-dark">Leaping - Personal Blog Template</Link>
                            <p className="text-muted para-desc mx-auto mt-2">If the distribution of letters and 'words' is
                                random, the reader will not be distracted from making a neutral judgement on the visual
                                impact and readability of the typefaces.</p>
                            <span className="text-muted mb-0">20th June 2023</span>
                        </div>
                    </div>
                    <div className="card blog blog-primary border-0 rounded-0">
                        <BlogAbout/>
                    </div>
                    <BlogComments/>
                </div>
                <div className="col-lg-4 col-md-6">
                    <BlogSidebar/>
                </div>
            </div>
        </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
